// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3Oi5y","hover":"NavigationItem_hover__2XFkA","Selected":"NavigationItem_Selected__36HT7"};